import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';

/**
 * Guard de rota admin-only (P2 / AJUSTES-POS-2).
 *
 * Encadeia depois do login: exige usuário autenticado E `isAdmin`. Usado em
 * ferramentas de dev (`/dev/ui`), que o comentário histórico já dizia serem
 * "só admins" mas ficavam abertas a qualquer logado.
 *
 * Semântica:
 *   - carregando sessão: não renderiza nada (evita flash).
 *   - não autenticado: redirect pra /login preservando a origem.
 *   - autenticado mas NÃO admin: redirect pra Home (`/`) — bloqueado.
 *   - admin: renderiza.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-paper dark:bg-paper-dark flex items-center justify-center">
        <div className="text-ink-3 dark:text-ink-dark-3 text-sm">Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
